export const DOCUMENTS_REQUEST = "DOCUMENTS_REQUEST"
export const DOCUMENTS_SUCCESS = "DOCUMENTS_SUCCESS"
export const DOCUMENTS_ERROR = "DOCUMENTS_ERROR"
export const CHECKUP_DOCUMENT_REQUEST = "CHECKUP_DOCUMENT_REQUEST"
export const CHECKUP_DOCUMENT_SUCCESS = "CHECKUP_DOCUMENT_SUCCESS"
export const CHECKUP_DOCUMENT_ERROR = "CHECKUP_DOCUMENT_ERROR"

export const SEND_DOCUMENTS_REQUEST = "SEND_DOCUMENTS_REQUEST"
export const SEND_DOCUMENTS_ERROR = "SEND_DOCUMENTS_ERROR"
export const SEND_DOCUMENTS_SUCCESS = "SEND_DOCUMENTS_SUCCESS"

export const SEND_CHECKUP_DOCUMENTS_REQUEST = "SEND_CHECKUP_DOCUMENTS_REQUEST"
export const SEND_CHECKUP_DOCUMENTS_ERROR = "SEND_CHECKUP_DOCUMENTS_ERROR"
export const SEND_CHECKUP_DOCUMENTS_SUCCESS = "SEND_CHECKUP_DOCUMENTS_SUCCESS"

export const CUSTOMER_DOCUMENTS_REQUEST = "CUSTOMER_DOCUMENTS_REQUEST"
export const CUSTOMER_DOCUMENTS_SUCCESS = "CUSTOMER_DOCUMENTS_SUCCESS"
export const CUSTOMER_DOCUMENTS_ERROR = "CUSTOMER_DOCUMENTS_ERROR"

export const CUSTOMER_DOCUMENT_PREVIEW_REQUEST = "CUSTOMER_DOCUMENT_PREVIEW_REQUEST"
export const CUSTOMER_DOCUMENT_PREVIEW_SUCCESS = "CUSTOMER_DOCUMENT_PREVIEW_SUCCESS"
export const CUSTOMER_DOCUMENT_PREVIEW_ERROR = "CUSTOMER_DOCUMENT_PREVIEW_ERROR"
export const CUSTOMER_DOCUMENT_PREVIEW_CLEAR = "CUSTOMER_DOCUMENT_PREVIEW_CLEAR"